/**
 * 运行时站点配置（构建期由 vue.config.js DefinePlugin 注入）
 * 开发时若未注入，回退到默认 blszf
 */
const fallback = {
  id: 'blszf',
  domain: 'blszf.com',
  title: '碧莲盛不剃发植发',
  description:
    '碧莲盛专注毛发健康与毛发移植，提供专业毛囊检测、毛发种植服务。针对发际线后移、毛发稀疏等各类脱发问题，定制自体毛发移植方案，重塑自然毛发形态。',
  keywords:
    '毛发种植,毛发移植,毛发加密,毛发再生,毛发修复,毛发健康,毛发稀疏,毛发脱落,毛发重建',
  dictType: 'blszf'
}

// eslint-disable-next-line no-undef
const siteConfig = typeof __SITE_CONFIG__ !== 'undefined' ? __SITE_CONFIG__ : fallback

export default siteConfig
